import * as React from "react";
import { Switch, Route, RouteComponentProps, Redirect } from "react-router";
import { Page } from "../components/Page";
import { RouteHelper } from "../helpers/RouteHelper";
import { LandingWineTemplateApiModel } from "../apiModels/LandingWineTemplateApiModel";
import { LandingWineTemplateSelectModal } from "../modals/LandingWineTemplateSelectModal";
import { RioIf, RioApiGet, RioApiPost, RioExpandingPanel, RioResources, RioDateHelpers, RioConfirmModal, RioApiDelete, RioIcon } from "rio.react.all";
//import { TemplatePDFDownloadModal } from "../modals/TemplatePDFDownloadModal";
//import { TemplateEmailCustomerSelectModal } from "../modals/TemplateEmailCustomerSelectModal";
import { LandingWineEmailEditorModal } from "../modals/LandingWineEmailEditorModal";
import { ErrorModal } from "../modals/ErrorModal";
import { HttpErrorHelper } from "../helpers/HttpErrorHelper";
import * as moment from "moment";
import { DataVineGridView } from "../components/GridView/GridView";
import { IGridViewColumn } from "../components/GridView/IGridViewColumn";
import { IGridViewAction } from "../components/GridView/IGridViewAction";
import { LandingWineType } from "../enums/LandingWineType";


interface ILandingWineTemplatesProps extends RouteComponentProps {

}

interface ILandingWineTemplatesState {
	LandingWineTemplatesEpWines: Array<LandingWineTemplateApiModel>;
	LandingWineTemplatesNonEpWines: Array<LandingWineTemplateApiModel>;
    downloadPDFCampaignID: number;
    sendTemplateId: number;
    selectedLandingWineTemplatestartDate: string;
	responseError: string;
	editLandingWineTempleID: number;
	landingWineTypeID: number;
	deleteID: number;
}

export class LandingWineTemplates extends React.Component<ILandingWineTemplatesProps, ILandingWineTemplatesState> {
    constructor(props: Readonly<ILandingWineTemplatesProps>) {
        super(props);

        this.state = {
			LandingWineTemplatesEpWines: [],
			LandingWineTemplatesNonEpWines: [],
            downloadPDFCampaignID: null,
            sendTemplateId: null,
            selectedLandingWineTemplatestartDate: null,
			responseError: null,
			editLandingWineTempleID: null,
			landingWineTypeID: null,
			deleteID: null,
        };
    }

	columns: Array<IGridViewColumn<LandingWineTemplateApiModel>> = [
		{ title: RioResources.find("Subject").text, displayValue: (item) => item.subject, value: (item) => item.subject },
		{ title: RioResources.find("DaysBeforeSend").text, displayValue: (item) => item.daysBeforeSend, value: (item) => item.daysBeforeSend },
		{ title: RioResources.find("CreatedOn").text, displayValue: (item) => RioDateHelpers.toDateFormat(item.createDate, "DD/MM/YYYY"), value: (item) => item.createDate },
		{ title: RioResources.find("lastActionDate").text, displayValue: (item) => RioDateHelpers.toDateFormat(item.lastActionDate, "DD/MM/YYYY"), value: (item) => item.lastActionDate },
    ];

	actions: Array<IGridViewAction<LandingWineTemplateApiModel>> = [
		{ resource: RioResources.find("Enabled"), className: "landingWineCampaignEnabledButton", onClick: (item) => this.handleEnableClicked(item), hasPermission: true, visible: (item) => item.active },
		{ resource: RioResources.find("Disabled"), className: "landingWineCampaignDisabledButton", onClick: (item) => this.handleEnableClicked(item), hasPermission: true, visible: (item) => !item.active },
		{ resource: RioResources.find("Select"), onClick: (item) => this.handleSelectClicked(item), disabled: (item) => !item.active, hasPermission: true },
		{ resource: RioResources.find("Edit"), onClick: item => this.handleDetailsClicked(item), hasPermission: true },
		{ resource: RioResources.find("Delete"), onClick: (item) => this.setState({ deleteID: item.landingWineTemplateID }), hasPermission: true },
    ];

    render() {
        return (
			<Page heading={RioResources.find("LandingWineTemplates")}>
				<div className="expandingPanel-side-by-side">
					<RioExpandingPanel
						className="noBackground showTitle"
						disableToggle={true}
						expandedDefault={true}
						title={RioResources.find("LandingWineEPWines").text}
						actions={[
							{ resource: RioResources.find("New"), onClick: () => this.newClicked(LandingWineType.Ep), hasPermission: true }
						]}
					>
						<DataVineGridView<LandingWineTemplateApiModel>
							noResults={RioResources.find("NoResultsFound")}
							columns={this.columns}
							actions={this.actions}
							items={this.state.LandingWineTemplatesEpWines}
							rowKey={(item: LandingWineTemplateApiModel) => item.landingWineTemplateID}
						/>

					</RioExpandingPanel>

					<RioExpandingPanel
						className="noBackground showTitle"
						disableToggle={true}
						expandedDefault={true}
						title={RioResources.find("LandingWineNonEPWines").text}
						actions={[
							{ resource: RioResources.find("New"), onClick: () => this.newClicked(LandingWineType.NonEp), hasPermission: true }
						]}
					>
						<DataVineGridView<LandingWineTemplateApiModel>
							noResults={RioResources.find("NoResultsFound")}
							columns={this.columns}
							actions={this.actions}
							items={this.state.LandingWineTemplatesNonEpWines}
							rowKey={(item: LandingWineTemplateApiModel) => item.landingWineTemplateID}
						/>
					</RioExpandingPanel>
				</div>
                

                {/*<RioIf condition={!!this.state.downloadPDFCampaignID} then={*/}
                {/*    <CampaignPDFDownloadModal onClose={() => this.handlePDFDownloadModalClosed()} templateId={this.state.downloadPDFCampaignID} />*/}
                {/*} />*/}


                <RioIf condition={!!this.state.responseError} then={
                    <ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
                } />

				<RioIf condition={this.state.editLandingWineTempleID != null} then={
					<LandingWineEmailEditorModal onClose={() => this.handleEditClosed()} id={this.state.editLandingWineTempleID} landingWineTypeID={this.state.landingWineTypeID} />
				} />

				<RioIf condition={!!this.state.deleteID} then={
					<RioConfirmModal text={RioResources.find("DeleteDocumentConfirmMsg")} onConfirmModalClosed={(result) => this.confirmItemDeleted(result)} className="confirmModal" />
				} />

     {/*           <Switch>*/}
     {/*               <Route exact path={this.props.match.path} /> { }*/}
     {/*               */}{/*<Route path={`${this.props.match.path}/copy/:copyId`} render={(props) => <TemplateEmailEditorModal onClose={() => this.loadData()} copyId={props.match.params.copyId} {...props} />} />*/}
					{/*<Route path={`${this.props.match.path}/:id`} render={(props) => <LandingWineEmailEditorModal onClose={() => this.loadData()} id={props.match.params.id} {...props} />} />*/}
     {/*               <Redirect to={"/LandingWineTemplates"} />*/}
				{/*           </Switch>*/}

            </Page>
        );
    }

    componentDidMount(): void {
        this.loadData();
    }

    loadData(): void {
		RioApiGet.asPromise<Array<LandingWineTemplateApiModel>>("/api/landingwinetemplate/get")
			.then(response => {
				this.setState({
					LandingWineTemplatesEpWines: response.filter(x => x.landingWineTypeID == LandingWineType.Ep).sort((a, b) => a.daysBeforeSend - b.daysBeforeSend),
					LandingWineTemplatesNonEpWines: response.filter(x => x.landingWineTypeID == LandingWineType.NonEp).sort((a, b) => a.daysBeforeSend - b.daysBeforeSend),
                });
            })
            .catch((response) => {
                var error = HttpErrorHelper.handleHttpError(response, this, null); //handles validator errors if validator passed
                this.setState({ responseError: error });
            });;
    }

	handleSendClicked(template: LandingWineTemplateApiModel): void {
        this.setState({
			sendTemplateId: template.landingWineTemplateID
        });
    }


	handleDetailsClicked(template: LandingWineTemplateApiModel): void {
		//RouteHelper.down(this as any, template.landingWineTemplateID);
		this.setState({
			editLandingWineTempleID: template.landingWineTemplateID,
			landingWineTypeID: template.landingWineTypeID,
		});
    }

	handleEnableClicked(template: LandingWineTemplateApiModel): void {
		template.active = !template.active;
		RioApiPost.asPromise("/api/LandingWineTemplate/TemplateAddUpdate/", template)
			.then((response) => {
				this.loadData();
			})
			.catch((response) => {
				this.setState({ responseError: response });
			});
	}

	confirmItemDeleted(result: boolean): void {
		if (result) {
			RioApiDelete.asPromise("/api/LandingWineTemplate/Delete/" + this.state.deleteID)
				.then((response) => {
					this.setState({
						deleteID: null
					});
					this.loadData();
				})
				.catch((response) => {
					this.setState({ responseError: response });
				});

		} else {
			this.setState({
				deleteID: null
			});
		}
	}

 //   handlePDFDownloadModalClosed() {
 //       this.setState({
 //           downloadPDFTemplateID: null
 //       });
 //	}

	handleEditClosed() {
		this.setState({
			editLandingWineTempleID: null
		});
		this.loadData();
	}

	newClicked(type: LandingWineType) {
		this.setState({
			editLandingWineTempleID: 0,
			landingWineTypeID: type,
		});
		this.loadData();
	}

	handleSelectClicked(item: LandingWineTemplateApiModel) {
		window.location.href = "/LandingWinesManualSend?id=" + item.landingWineTemplateID.toString();
	}
}
